"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPropIncluded;
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
function isPropIncluded(props, prop) {
  return (0, _keys.default)(props).some(function (key) {
    return key === prop;
  });
}